import Cookies from 'universal-cookie';

export const COOKIE_SETTINGS = {
    "AUTH_DURATION": 60*60*24*365
}

const SHARED_COOKIE_DOMAIN = '.almaconnect.com';
const MIGRATION_FLAG = 'cookie_domain_migrated_v2';
const SHARED_COOKIE_NAMES = ['api_key', 'team_id'];

function isLocalHost(host) {
    return host === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(host);
}

function getCookieDomain() {
    if (typeof window === 'undefined') return undefined;
    const host = window.location.hostname;
    if (isLocalHost(host)) return undefined;
    if (host === 'almaconnect.com' || host.endsWith('.almaconnect.com')) {
        return SHARED_COOKIE_DOMAIN;
    }
    return undefined;
}

function isHttpsContext() {
    if (typeof window === 'undefined') return false;
    return window.location.protocol === 'https:';
}

export function getCookieSetOptions() {
    return {
        path: '/',
        maxAge: COOKIE_SETTINGS.AUTH_DURATION,
        domain: getCookieDomain(),
        secure: isHttpsContext(),
        sameSite: 'lax',
    };
}

export function getCookieRemoveOptions() {
    return {
        path: '/',
        domain: getCookieDomain(),
    };
}

export function removeSharedCookie(cookies, name) {
    cookies.remove(name, { path: '/' });
    if (getCookieDomain()) cookies.remove(name, getCookieRemoveOptions());
}

export function migrateHostOnlyCookies() {
    if (typeof window === 'undefined') return;
    if (!getCookieDomain()) return;
    let storage;
    try {
        storage = window.localStorage;
        if (storage.getItem(MIGRATION_FLAG)) return;
    } catch (e) {
        return;
    }
    const cookies = new Cookies();
    const snapshot = {};
    SHARED_COOKIE_NAMES.forEach((name) => {
        snapshot[name] = cookies.get(name);
    });
    SHARED_COOKIE_NAMES.forEach((name) => {
        cookies.remove(name, { path: '/' });
    });
    SHARED_COOKIE_NAMES.forEach((name) => {
        if (snapshot[name] != null) {
            cookies.set(name, snapshot[name], getCookieSetOptions());
        }
    });
    try {
        storage.setItem(MIGRATION_FLAG, '1');
    } catch (e) {}
}
